module.exports = __webpack_public_path__ + "static/media/vim_logo.f66c5ef1.jpg";